const hasOwn = {}.hasOwnProperty;
function cx(...args) {
    const classes = [];
    for (let i = 0; i < args.length; i++) {
        const arg = args[i];
        if (!arg)
            continue;
        const argType = typeof arg;
        if (argType === 'string' || argType === 'number') {
            classes.push(arg);
        }
        else if (Array.isArray(arg)) {
            if (arg.length) {
                const inner = { ...arg };
                if (inner) {
                    classes.push(inner);
                }
            }
        }
        else if (argType === 'object') {
            if (arg.toString === Object.prototype.toString) {
                for (const key in arg) {
                    if (hasOwn.call(arg, key) && arg[key]) {
                        classes.push(key);
                    }
                }
            }
            else {
                classes.push(arg.toString());
            }
        }
    }
    return classes.join(' ');
}
export function cssFactory() {
    // This is a factory function to allow for scalability
    return { cx };
}
